//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';

export const getUserFullName = createSelector(
  (state: ICuralateStore) => state.session.user,
  (user) => `${user.firstName} ${user.lastName}`,
);
